import React, { useId } from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import { dashboard2SectionPanelSx } from "../dashboard2-status.styles";
import { Dashboard2SectionFieldsetLegend } from "./Dashboard2SectionFieldsetLegend";

type Dashboard2SectionPanelProps = {
  icon: React.ReactNode;
  title: string;
  description?: string;
  panelSx?: SxProps<Theme>;
  /** Merged onto the outer stack after the shared panel styles. */
  rootSx?: SystemStyleObject<Theme>;
  iconSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  headerSx?: SxProps<Theme>;
  bodyRef?: React.Ref<HTMLElement | null>;
  children: React.ReactNode;
  "data-testid"?: string;
  headerTestId?: string;
};

export const Dashboard2SectionPanel: React.FC<Dashboard2SectionPanelProps> = ({
  icon,
  title,
  description,
  panelSx,
  rootSx,
  iconSx,
  titleSx,
  headerSx,
  bodyRef,
  children,
  "data-testid": testId,
  headerTestId
}) => {
  const headerId = useId();

  return (
    <Box
      sx={rootSx ? [dashboard2SectionPanelSx, rootSx] : dashboard2SectionPanelSx}
      data-testid={testId}
    >
      <Dashboard2SectionFieldsetLegend
        id={headerId}
        icon={icon}
        title={title}
        description={description}
        legendSx={headerSx}
        iconSx={iconSx}
        titleSx={titleSx}
        data-testid={headerTestId}
      />
      <Box
        ref={bodyRef}
        sx={panelSx}
        role="region"
        aria-labelledby={headerId}
        data-testid={testId ? `${testId}-body` : undefined}
      >
        {children}
      </Box>
    </Box>
  );
};
